module.exports = __webpack_public_path__ + "img/web1.0c8f5fd4.png";